/*
 * Copyright (c) 2022-2023. Haodong JU
 */

import GlobalSettings from '@/model/global/GlobalSettings'
import IKDataEntity from '@/plugins/EntityFrameWork/IKDataEntity'
import hillo from 'hillo'
import ConsumeType from '@/model/dataLayer/api/buffet/ConsumeType'
import CategoryType from '@/model/dataLayer/api/dish/CategoryType'

const entity = {
  id: {
    type: IKDataEntity.Types.Integer,
    displayName: 'id',
    tableConfig: {
      align: 'start'
    },
    formConfig: {
      requiredEdit: false,
      requiredNew: false
    }
  },
  consumeTypeId: {
    type: IKDataEntity.Types.Option,
    formConfig: {
      // requiredEdit: false,
      type: {
        selectItems: ConsumeType.getList
      }
    }
  },
  dishesCategoryTypeId: {
    displayName: 'TaxType',
    type: IKDataEntity.Types.Option,
    formConfig: {
      // requiredEdit: false,
      type: {
        selectItems: async () => {
          const res = (await CategoryType.getList(true))
          res.forEach(it => {
            it.name = it._langsname
          })
          return res
        }
      }
    }
  },
  taxRateValue: {
    displayName: 'TaxRate'
  }
}
const config = {
  edit: function (item) {
    return hillo.postWithUploadFile('TaxRate.php?op=update', item)
  },
  load: async function (filter) {
    const res = ((await hillo.get('TaxRate.php?', {
      op: 'getList',
      lang: GlobalSettings.getLang(),
      ...filter
    })).content)
    console.log(res, 'res')
    return res
  }
}

export default IKDataEntity.ModelFactory(entity, config)
